import { Copy, MoreHorizontal, Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/ui/design-system/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
    Text,
} from '@/ui/design-system/components';

// Row subtitle, e.g. "5 widgets · <synthesis…>". Once a synthesis has been
// written back to config.analysis we show its text (single-line truncated by
// the subtitle's max-width below) rather than a generic label; before then it's
// just the widget count.
const formatReportMeta = (config = {}) => {
    const count = config.widgets?.length ?? 0;
    const widgets = `${count} widget${count === 1 ? '' : 's'}`;
    const summary = config.analysis?.text?.trim();
    return summary ? `${widgets} · ${summary}` : widgets;
};

// One row in the "My Reports" list: the title/metadata are a Link (whole text
// block opens the report) and the ⋯ menu is a sibling — never nested in the
// anchor — so opening the menu doesn't trigger navigation.
function ReportListItem({ report, onDuplicate, onDelete }) {
    const { config } = report;
    const title = config?.title || config?.prompt || 'Untitled report';

    return (
        <div className="group flex items-center gap-5 rounded-xl border bg-background px-5 py-5 transition-colors hover:border-med-em">
            <Link
                to={`/reports/${report.id}/view`}
                className="flex min-w-0 flex-1 flex-col gap-2"
            >
                <Text size="sm" weight="medium" className="truncate">
                    {title}
                </Text>
                <Text
                    size="sm"
                    color="muted"
                    className="max-w-[480px] truncate"
                >
                    {formatReportMeta(config)}
                </Text>
            </Link>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button
                        variant="ghost"
                        size="icon"
                        aria-label="Report actions"
                    >
                        <MoreHorizontal />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    <DropdownMenuItem onSelect={() => onDuplicate(report)}>
                        <Copy /> Duplicate
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem
                        onSelect={() => onDelete(report.id)}
                        className="text-destructive focus:text-destructive"
                    >
                        <Trash2 /> Delete
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}

export { formatReportMeta };
export default ReportListItem;
